/**
 * Apply `{key: value}` edits to a searchParams snapshot — `null` deletes the
 * key. Returns a new object; the caller's snapshot is react-router's, and
 * mutating it would edit the URL around the router rather than through it.
 *
 * Lives here rather than beside the hook that uses it because it is pure —
 * `URLSearchParams` in, `URLSearchParams` out, no imports — so it belongs in
 * the React-free half of the app like `dateRange.ts` and `quarters.ts`.
 */
export function withParams(
  prev: URLSearchParams,
  updates: Record<string, string | null>,
): URLSearchParams {
  const p = new URLSearchParams(prev);
  for (const [key, value] of Object.entries(updates)) {
    if (value === null) p.delete(key);
    else p.set(key, value);
  }
  return p;
}
